"use strict";

$(document).ready(function () {

    function _get_form_token() {
        $.get(site_url + '/ajax/functions.php?operation=_get_form_token', function (resp) {
            $("input[name=_token][type=hidden]").each(function () {
                this.value = resp;
            });
        });
    }
    $(function () {
        _get_form_token();
    });

    var saving_days = document.getElementById("savingDays");

    // Set the date we're counting down to
    var countDownDate = new Date("Dec 2, 2019 00:00:01").getTime();

    // Update the count down every 1 second
    var x = setInterval(function () {

        // Get today's date and time
        var now = new Date().getTime();

        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
        var seconds = Math.floor(distance % (1000 * 60) / 1000);

        if (saving_days) {
            if (now < countDownDate) {
                // Output the result in an element with id="demo"
                document.getElementById("savingDays").innerHTML = "<div class='hour'>" + days + "<span>days </span></div>" + "<div class='hour'>" + hours + "<span>hrs </span></div>" + "<div class='hour'>" + minutes + "<span>min </span></div>" + "<div class='hour'>" + seconds + "<span>sec </span> </div>";

                // If the count down is over, write some text 
                if (distance < 0) {
                    clearInterval(x);
                    document.getElementById("savingDays").innerHTML = "EXPIRED";
                }
            }
        }
    }, 1000);

    //target in pages
    var url = window.location.href;

    if (url.indexOf('#') > -1) {
        var target = url.split('#')[1];
        //console.log(target);
        //$('body, html').animate({ scrollTop: $('#'+target).offset().top - 220},800, 'easeOutExpo');
    }

    //Call function with browser is resized.
    $(window).resize(function (event) {
        resizeWindow();
    });
    resizeWindow();

    //Acts when scroll down page.
    $(window).scroll(function (event) {
        scrollDown();
        var top = $(document).scrollTop();
        if (top > 100) {
            //$('header').addClass('sticky');
        } else {
                //$('header').removeClass('sticky');
            }
        if ($('.map-section').length > 0) {
            var elemetScrolled = $('.map-section').offset().top - 400;
            if (top >= elemetScrolled) {
                $('.map-section').addClass('fadeIn');
            }
        }
    });

    // Main Nav Dropdown
    $("#primary-nav li").hover(function () {

        $(this).addClass("hover");
        $('ul.submenu', this).fadeIn(200);
    }, function () {

        $(this).removeClass("hover");
        $('ul.submenu', this).fadeOut(200);
    });

    //Home page scroll down arrow. If present.
    $('.arrow-home').click(function (event) {
        $('body, html').animate({
            scrollTop: $(window).height() - $('header').outerHeight() * 2
        }, 800, 'easeOutExpo');
    });

    //Close Banner Hurricane
    $('.close-icon').click(function () {
        $('.hurricane-notice').fadeOut(200);
    });

    //Remove empty <p> tags created by tinymce
    $('p').each(function () {
        var $this = $(this);
        if ($this.html().replace(/\s|&nbsp;/g, '').length == 0) $this.remove();
    });

    //Event Tracking
    //this class should be add to any link to the booking engine
    $('.book-now').on('click', function () {
        if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
        gtag('event', 'conversion', { 'send_to': 'AW-825580960/uXRWCMqts4UBEKC71YkD' });
    });
    //this class should be add to the header widget submit button
    $('.bookNow').on('click', function () {
        if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
        gtag('event', 'conversion', { 'send_to': 'AW-825580960/uXRWCMqts4UBEKC71YkD' });
    });

    //Check in and check out datepicker for booking engine
    $("#CheckIn").datepicker({
        //showOn: "both",
        //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
        //buttonImageOnly: true,
        changeMonth: true,
        numberOfMonths: 1,
        //minDate: 0,
        minDate: '2020-07-01',
        dateFormat: 'yy-mm-dd',
        onSelect: function onSelect(selectedDate) {
            var getDate = $(this).datepicker('getDate');
            var newDate = new Date(getDate.getTime());
            newDate.setDate(newDate.getDate() + 3);
            $("#CheckOut").datepicker("setDate", newDate);
            $("#CheckOut").datepicker("option", "minDate", selectedDate);
        }
    });

    $("#CheckOut").datepicker({
        //showOn: "both",
        //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
        //buttonImageOnly: true,
        changeMonth: true,
        numberOfMonths: 1,
        dateFormat: 'yy-mm-dd',
        //minDate: 0,
        minDate: '2020-07-01',
        onSelect: function onSelect(selectedDate) {
            $("#CheckIn").datepicker("option", "maxDate", selectedDate);
        }
    });

    $(".datepicker").datepicker({
        changeMonth: true,
        numberOfMonths: 1,
        dateFormat: 'yy-mm-dd',
        minDate: 'today'
    });

    //cyber monday counter this shows on the homepage and landing page
    // if(($('body#home').length > 0) || ($('body#cyber_sale').length > 0)){
    //     //Index Countdown
    //     var day = $('#day').val();
    //     var month = $('#month').val();
    //     var year = $('#year').val();
    //     var hour = $('#hour').val();
    //     var minute = $('#min').val();
    //     var second = $('#sec').val();
    //     setTimeout(function () {
    //         $('#countdown').countDown({
    //             targetDate: {
    //                 'day': day,
    //                 'month': month,
    //                 'year': year,
    //                 'hour': hour,
    //                 'min': minute,
    //                 'sec': second
    //             },
    //             omitWeeks: true
    //         });
    //     }, 800)
    // }

    //Sitemap
    var siteli = $('ul.global-sitemap > li').length;
    var cont = 1;
    $('ul.global-sitemap > li').each(function () {
        $(this).addClass('checked' + cont);
        cont++;
        if (cont > 3) {
            cont = 1;
        }
    });
    $('ul.global-sitemap > li.checked1').wrapAll('<div class="col-md-4"></div>');
    $('ul.global-sitemap > li.checked2').wrapAll('<div class="col-md-4"></div>');
    $('ul.global-sitemap > li.checked3').wrapAll('<div class="col-md-4"></div>');

    $('ul.global-sitemap > li.checked1').removeClass('checked1');
    $('ul.global-sitemap > li.checked2').removeClass('checked2');
    $('ul.global-sitemap > li.checked3').removeClass('checked3');

    if ($('.global-sitemap').length > 0) {
        $('.global-sitemap').insertAfter($('#content #bottom-content .intro .separator'));
    }

    // Map: Return to previous page button. Change body id to match map template's name.
    //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

    $('.center').slick({
        arrows: true,
        centerMode: true,
        centerPadding: '',
        infinite: true,
        slidesToShow: 1,
        accessibility: false
    });

    $('#booking-form').submit(function () {
        event.preventDefault();
        var form = $(this).attr('id');
        var bookingUrl = $(this).find('input[name=booking-url]').val();
        var checkIn = $(this).find('#CheckIn').val();
        var checkOut = $(this).find('#CheckOut').val();
        var newDate = new Date();
        var dd = newDate.getDate();
        var mm = newDate.getMonth() + 1;
        var yyyy = newDate.getFullYear();
        var ddOut = newDate.getDate() + 3;
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (ddOut < 10) {
            ddOut = '0' + ddOut;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        if (checkIn == 'Check In') {
            checkIn = yyyy + '-' + mm + '-' + dd;
        }
        if (checkOut == 'Check Out') {
            checkOut = yyyy + '-' + mm + '-' + ddOut;
        }
        var adultsNumber = $(this).find('#adult').val();
        var childNumber = $(this).find('#child').val();

        var URLResult = bookingUrl + '?adults=' + adultsNumber + '&checkInDate=' + checkIn + '&checkOutDate=' + checkOut + '&minors=' + childNumber;
        window.open(URLResult, '_blank');
    });

    $('.burger').click(function () {
        var wHeight = $(window).height() - 150;
        $('#primary-nav').height(wHeight);
        if (!$('#primary-nav').hasClass('tablet')) {
            $('#primary-nav').addClass('tablet');
            $('#primary-nav').wrapInner('<div class="wrap"></div>');
        }
        if (!$(this).hasClass('open')) {
            $(this).addClass('open');
            $('#primary-nav').slideDown();
        } else {
            $(this).removeClass('open');
            $('#primary-nav').slideUp();
        }
    });

    $('form .btn.btnSubmit').click(function () {
        setTimeout(function () {
            $('p#thankyou').fadeOut(500);
        }, 6000);
    });
});

$(window).on('load', function () {

    //Slick Slider
    $('.sym-slides').slick();
});

function scrollDown() {}

function resizeWindow() {}

if (page_id == 11585) {

    // Update the count down every 1 second
    var x = setInterval(function () {

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for hours, minutes and seconds
        var hours = 0;
        var minutes = 0;
        var seconds = 0;
        while (true) {
            if (distance >= 1000 * 60 * 60) {

                hours++;
                distance -= 1000 * 60 * 60;
            } else if (distance >= 1000 * 60) {

                minutes++;
                distance -= 1000 * 60;
            } else if (distance >= 1000) {

                seconds++;
                distance -= 1000;
            } else break;
        } // Format output-string
        var hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;

        // Display the result in the element with id="demo"
        if (distance > 0) {
            document.getElementById("hours").innerHTML = hours;
            document.getElementById("minutes").innerHTML = minutes;
            document.getElementById("seconds").innerHTML = seconds;
        } else document.getElementById("hours").innerHTML = "EXPIRED";
    }, 1000);
}